import React from 'react';
import { useSearchParams } from 'react-router';
import AuditSidebar from './AuditSidebar';
import AuditorDashboardContent from './AuditorDashboardContent';
import AuditorProceduresContent from './AuditorProceduresContent';
import MyProceduresContent from './MyProceduresContent';
import MyFindingsContent from './MyFindingsContent';
import Breadcrumb from '../../components/navigation/Breadcrumb';

/**
 * Audit User Dashboard
 * A simple blank dashboard with orange/amber theme to test role-based routing
 */

interface AuditorDashboardProps {
  sidebarOpen?: boolean;
}

const AuditorDashboard: React.FC<AuditorDashboardProps> = ({ sidebarOpen = false }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('view') || 'dashboard';

  const setActiveTab = (tab: string) => {
    setSearchParams({ view: tab });
  };

  return (
    <div className="audit-layout">
      <AuditSidebar activeTab={activeTab} onTabChange={setActiveTab} isOpen={sidebarOpen} />
      <div className="audit-main-content">
        {activeTab === 'dashboard' && (
          <div className="audit-tab-page">
            <Breadcrumb
              items={[
                { key: 'home', label: '', icon: '🏠', onClick: () => setActiveTab('dashboard') },
                { key: 'dashboard', label: 'Dashboard', icon: '📊', isCurrent: true },
              ]}
            />
            <AuditorDashboardContent />
          </div>
        )}
        {activeTab === 'procedures' && (
          <div className="audit-tab-page">
            <Breadcrumb
              items={[
                { key: 'home', label: '', icon: '🏠', onClick: () => setActiveTab('dashboard') },
                { key: 'procedures', label: 'Procedures', icon: '📄', isCurrent: true },
              ]}
            />
            <AuditorProceduresContent />
          </div>
        )}
        {activeTab === 'my-procedures' && (
          <div className="audit-tab-page">
            <Breadcrumb
              items={[
                { key: 'home', label: '', icon: '🏠', onClick: () => setActiveTab('dashboard') },
                { key: 'my-procedures', label: 'Procedures', icon: '📋', isCurrent: true },
              ]}
            />
            <MyProceduresContent />
          </div>
        )}
        {activeTab === 'my-findings' && (
          <div className="audit-tab-page">
            <Breadcrumb
              items={[
                { key: 'home', label: '', icon: '🏠', onClick: () => setActiveTab('dashboard') },
                { key: 'my-findings', label: 'My Findings', icon: '🚩', isCurrent: true },
              ]}
            />
            <MyFindingsContent />
          </div>
        )}
      </div>
    </div>
  );
};

export default AuditorDashboard;
